import { User } from "../../../ducks/user";
import { PlusIcon } from "../../atoms/icons/PlusIcon";
import { MainTemplate } from "../../templates/MainTemplate";
import { TableTemplate } from "../../templates/TableTemplate";
import { useUsers } from "./hook";

export const UsersPage: React.FC = () => {
  const {
    canCreate,
    users,
    tableHeaders,
    fetchUsers,
    handleRegistration,
    handleEdit,
  } = useUsers();

  return (
    <MainTemplate
      title="アカウント一覧"
      number={users ? `（${users.length}件）` : ""}
      button={
        canCreate
          ? {
              text: "新規アカウント登録",
              variant: "filled",
              onClick: handleRegistration,
              icon: PlusIcon,
            }
          : undefined
      }
      useFitHeight
    >
      <TableTemplate<User>
        headers={tableHeaders}
        data={users ?? []}
        fetchDataFunction={fetchUsers}
        editable
        onEdit={handleEdit}
        defaultEmptyText={users ? "アカウント情報がありません" : "データ取得中"}
        stickyHeader
      />
    </MainTemplate>
  );
};
